import classes from "./CreateButton.module.css";
import {IconPlus} from "@tabler/icons-react";
import {useContext} from "react";
import CreateFolderDialogContext from "../../../../../../components/dialogs/folder/create/CreateFolderDialogContext";

function CreateButton() {
    /**
     * Dialog context
     * @author Kacper Faber
     * @since 0.1.9
    */
    const dialogContext = useContext(CreateFolderDialogContext);

    /**
     * When button is clicked.
     * @author Kacper Faber
     * @since 0.1.9
    */
    const onClick = () => {
        dialogContext.setOpened(true);
    };

    return (
        <div className={classes.root} onClick={onClick}>
            <div className={classes.container}>
                <IconPlus/>

                <div className={classes.title}>
                    NOWY
                </div>
            </div>
        </div>
    );
}

export default CreateButton;